import { render, staticRenderFns } from "./ChainTableCell.vue?vue&type=template&id=6f8dfd0e"
import script from "./ChainTableCell.vue?vue&type=script&lang=js"
export * from "./ChainTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports